import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStickyNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M28.5 20.002L20.5 27.9966L5.83628 28.002C5.09827 28.002 4.5 27.4088 4.5 26.6774V5.32649C4.5 4.59497 5.09327 4.00195 5.82453 4.00195H27.1755C27.9069 4.00195 28.5 4.60963 28.5 5.33858V20.002ZM25.8333 6.66862H7.16667V25.3353H17.8333V18.6686C17.8333 17.9849 18.348 17.4213 19.0112 17.3442L19.1667 17.3353L25.8333 17.334V6.66862ZM24.728 20.0006L20.5 20.002V24.2273L24.728 20.0006Z",
			fill: "currentColor"
		})
	})
});
export default SvgStickyNote;
